import React, { useEffect, useState } from 'react';
import { api } from '../../utils/api';
import ModalOverlay from '../../components/ModalOverlay';
import './Admin.css';

const STATUS_LABEL = { unread: '미확인', read: '확인', replied: '답변완료' };

export default function AdminInquiries() {
  const [inquiries, setInquiries] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.getInquiries().then(setInquiries).catch(() => {});

  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    await api.updateInquiryStatus(id, status);
    load();
    if (selected?.id === id) setSelected((prev) => ({ ...prev, status }));
  };

  const remove = async (id) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    await api.deleteInquiry(id);
    setSelected(null);
    load();
  };

  const openDetail = async (inq) => {
    setSelected(inq);
    if (inq.status === 'unread') changeStatus(inq.id, 'read');
  };

  return (
    <div>
      <div className="admin-page-header">
        <div className="admin-page-title">문의 내역</div>
        <div className="admin-page-sub">홈페이지를 통해 접수된 문의를 관리합니다.</div>
      </div>

      <div className="admin-card">
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>이름</th>
                <th>이메일</th>
                <th>전화번호</th>
                <th>회사</th>
                <th>상태</th>
                <th>접수일시</th>
                <th>작업</th>
              </tr>
            </thead>
            <tbody>
              {inquiries.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign: 'center', color: '#64748b' }}>문의가 없습니다.</td></tr>
              )}
              {inquiries.map((inq) => (
                <tr key={inq.id} style={{ fontWeight: inq.status === 'unread' ? 600 : 400 }}>
                  <td>
                    <button
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#2563eb', fontWeight: 'inherit', padding: 0 }}
                      onClick={() => openDetail(inq)}
                    >
                      {inq.name}
                    </button>
                  </td>
                  <td>{inq.email}</td>
                  <td>{inq.phone || '-'}</td>
                  <td>{inq.company || '-'}</td>
                  <td>
                    <span className={`badge badge-${inq.status}`}>{STATUS_LABEL[inq.status]}</span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {new Date(inq.created_at).toLocaleString('ko-KR')}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <select
                      className="form-select"
                      style={{ padding: '4px 8px', fontSize: '0.8rem', width: 'auto' }}
                      value={inq.status}
                      onChange={(e) => changeStatus(inq.id, e.target.value)}
                    >
                      <option value="unread">미확인</option>
                      <option value="read">확인</option>
                      <option value="replied">답변완료</option>
                    </select>
                    {' '}
                    <button className="btn btn-danger btn-sm" onClick={() => remove(inq.id)}>삭제</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {selected && (
        <ModalOverlay onClose={() => setSelected(null)}>
          <div className="modal-title">문의 상세</div>
            <div className="inquiry-detail-row">
              <span className="inquiry-detail-label">이름</span>
              <span>{selected.name}</span>
            </div>
            <div className="inquiry-detail-row">
              <span className="inquiry-detail-label">이메일</span>
              <span>{selected.email}</span>
            </div>
            {selected.phone && (
              <div className="inquiry-detail-row">
                <span className="inquiry-detail-label">전화</span>
                <span>{selected.phone}</span>
              </div>
            )}
            {selected.company && (
              <div className="inquiry-detail-row">
                <span className="inquiry-detail-label">기관</span>
                <span>{selected.company}</span>
              </div>
            )}
            <div style={{ marginTop: 12 }}>
              <div className="form-label">문의 내용</div>
              <div className="inquiry-message-box">{selected.message}</div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-danger" onClick={() => remove(selected.id)}>삭제</button>
              <button className="btn btn-secondary" onClick={() => setSelected(null)}>닫기</button>
            </div>
        </ModalOverlay>
      )}
    </div>
  );
}
